import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class ImageAccordions {
  constructor(section) {
    this.container = section.container;
    this.imageAccordionsItems = this.container.querySelectorAll(s.selectors$j.item);
    this.buttons = this.container.querySelectorAll(s.selectors$j.button);
    this.accordionExpandEvent = (item) => this.accordionExpand(item);
    this.accordionFocusEvent = (item) => this.accordionFocus(item);

    this.init();
  }

  init() {
    this.imageAccordionsItems.forEach((item) => {
      item.addEventListener('mouseenter', this.accordionExpandEvent.bind(this, item));
    });

    this.buttons.forEach((button) => {
      button.addEventListener('focusin', this.accordionFocusEvent.bind(this, button));
    });
  }

  accordionExpand(item) {
    if (!item.classList.contains(c.classes$e.isExpanded)) {
      this.imageAccordionsItems.forEach((item) => {
        item.classList.remove(c.classes$e.isExpanded);
      });
      item.classList.add(c.classes$e.isExpanded);
    }
  }

  accordionFocus(button) {
    button.closest(s.selectors$j.item).dispatchEvent(new Event('mouseenter'));
  }

  onBlockSelect(evt) {
    const element = evt.target;
    if (element) {
      element.dispatchEvent(new Event('mouseenter'));
    }
  }
}